import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Collapse, Divider, Flex, Form, Input, InputNumber, Radio, Row, Select, Space, TreeSelect } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { buscarTipoTaxaImposto } from "../../../../services/tipoTaxaImpostoService";
import { buscarGrupoPlanoContaFinanceiro } from "../../../../services/grupoPlanoContaFinanceiroService";
import { BuscaCentroCustoTreeModel } from "../../../../models/centroCusto/buscaCentroCustoTreeModel";
import { buscarPessoa } from "../../../../services/pessoaService";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarTaxaImposto, cadastrarTaxaImposto } from "../../../../services/taxaImpostoService";
import { TaxaImpostoModel } from "../../../../models/taxaImposto/taxaImpostoModel";
import { setPageTaxaImposto } from "../../../../redux/slices/taxaImposto/taxaImpostoSlice";
import { SelectModel } from "../../../../models/treeModel";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { Vm_ContaBancoModel } from "../../../../models/contaBanco/vm_contaBancoModel";
import { PessoaModel } from "../../../../models/pessoa/pessoaModel";
import { buscarCentroCusto } from "../../../../services/centroCustoService";
import { buscarPlanoContaFinanceiro } from "../../../../services/planoContaFinanceiroService";
import SelectTree from "../../../../components/inputs/selectTree";

const { Panel } = Collapse;

const CadastrarPage = () => {
  //estados globais
  const taxaImpostoState = useAppSelector((state) => state.taxaImposto);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const tipoTaxaImpostoState = useAppSelector((state) => state.tipoTaxaImposto);
  const pessoaState = useAppSelector((state) => state.pessoa);
  const centroCustoState = useAppSelector((state) => state.centroCusto);
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<any>();
  const [grupo, setGrupo] = useState("");
  const [geraContaIsChecked, setIsChecked] = useState(taxaImpostoState.entity.geraContaFinanceira);
  const [usaMesmoPlanoIsChecked, setUsaMesmoPlanoChecked] = useState(taxaImpostoState.entity.conta_UsaPlanoContaFinanceiroOrigem);
  const [usaMesmoCentroCustoIsChecked, setUsaMesmoCentroCustoChecked] = useState(taxaImpostoState.entity.conta_UsaCentroCustoOrigem);

  const editar = Object.values(taxaImpostoState.entity).length !== 0;
  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    dispatch(buscarContaBanco(contaBancoState.busca));
    dispatch(buscarTipoTaxaImposto(tipoTaxaImpostoState.busca));
    dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
    dispatch(buscarCentroCusto({ ...centroCustoState.busca, receita: null, despesa: true }));
    dispatch(buscarPessoa({ ...pessoaState.busca, idCategoriaPessoa: "1", exibeContaPagar: true, exibeContaReceber: null }));
    if (editar) {
      dispatch(setTitle("EDITAR IMPOSTO / TAXA"));
      form.setFieldsValue({
        ...taxaImpostoState.entity,
      });
    } else {
      dispatch(setTitle("NOVO IMPOSTO / TAXA"));
      form.setFieldValue("ativo", true);
      form.setFieldValue("tipoValorImposto", "P");
      form.setFieldValue("geraContaFinanceira", false);
    }
  }, [taxaImpostoState.entity]);

  const submit = (value: any) => {
    if (editar) {
      const updateTaxaImposto = { id: taxaImpostoState.entity.id, ...value };
      dispatch(atualizarTaxaImposto({ value: updateTaxaImposto, busca: taxaImpostoState.busca }));
    } else {
      const cadastroTaxaImposto: TaxaImpostoModel = { ...value };

      cadastroTaxaImposto.conta_IdCentroCusto = Number(value.conta_IdCentroCusto);
      cadastroTaxaImposto.conta_IdPessoaFornecedor = Number(value.conta_IdPessoaFornecedor);
      cadastroTaxaImposto.idTipoTaxaImposto = typeof value.uf !== "string" ? Number(value.idTipoTaxaImposto) : 1;
      cadastroTaxaImposto.dataConta_NumeroAdiante = Number(value.numeroAdiante);
      cadastroTaxaImposto.dataConta_Dia = Number(value.dia);
      dispatch(cadastrarTaxaImposto({ value: cadastroTaxaImposto, busca: taxaImpostoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setTitle("IMPOSTOS E TAXAS"));
    dispatch(setPageTaxaImposto("geral"));
  };

  const handleFornecedorChange = (value: any) => {
    if (form.getFieldValue("conta_IdPessoaFavorecido") === undefined) {
      form.setFieldValue("conta_IdPessoaFornecedor", value);
    }
  };

  const handleChangeGrupo = (value: number) => {
    dispatch(buscarPlanoContaFinanceiro({ ...planoContaFinanceiroState.busca, receitaDespesa: "D", idGrupoPlanoContaFinanceiro: value }));
    const [grupo] = grupoPlanoContaFinanceiroState.list.filter((grupo: any) => grupo.id === value);
    form.setFieldValue("conta_IdPlanoContaFinanceiro", null);
    setGrupo(grupo.denominacao);
  };

  const handleGeraContaFinanceiraChange = (e: any) => {
    setIsChecked(e.target.checked);
  };

  const handleUsaMesmoPlanoChange = (e: any) => {
    setUsaMesmoPlanoChecked(e.target.checked);
    form.setFieldValue("conta_IdPlanoContaFinanceiro", null);
  };

  const handleUsaMesmoCentroCustoChange = (e: any) => {
    setUsaMesmoCentroCustoChecked(e.target.checked);
    form.setFieldValue("conta_IdCentroCusto", null);
  };

  const generateTree = (value: SelectModel[] = []) => {
    var retorno: any[] = [];
    value.map(({ children, ...props }: any) => {
      if (children?.length === 0) {
        children = undefined;
      }
      retorno.push({
        value: props.id,
        title: props.title,
        disabled: props.sinteticoAnalitico?.toLowerCase() === "s" || children !== undefined || !props.ativo,
        children: generateTree(children),
      });
    });
    return retorno;
  };

  const [selectedOption, setSelectedOption] = useState(taxaImpostoState.entity.tipoValorImposto != null ? taxaImpostoState.entity.tipoValorImposto : "P");

  return (
    <Flex gap={12} vertical>
      <Flex onClick={voltar} className="voltar">
        {"<"} VOLTAR
      </Flex>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12}>
          <Col span={4}>
            <Form.Item
              label="Nome do imposto / taxa"
              name="denominacao"
              rules={[
                {
                  required: true,
                  message: "Digite um nome do imposto/taxa",
                },
              ]}
            >
              <Input type="text" ref={inputInicial} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Nome abreviado"
              name="abreviacao"
              rules={[
                {
                  required: true,
                  message: "Digite a abreviação do imposto/taxa",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Tipo de imposto / taxa"
              name="idTipoTaxaImposto"
              rules={[
                {
                  required: true,
                  message: "Selecione um tipo de imposto/taxa",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Selecione um tipo de taxa/imposto"
                loading={tipoTaxaImpostoState.loading}
                options={tipoTaxaImpostoState.list.map((a: any) => ({
                  value: a.id,
                  label: a.denominacao,
                }))}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Situação" name="ativo" valuePropName="checked">
              <Checkbox>Ativo</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ alignItems: "flex-end" }}>
          <Col>
            <Form.Item name="tipoValorImposto">
              <Radio.Group defaultValue={selectedOption} buttonStyle="solid" onChange={(e) => setSelectedOption(e.target.value)}>
                <Radio.Button value="V">R$</Radio.Button>
                <Radio.Button value="P">%</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
          {selectedOption === "V" && (
            <Col>
              <Form.Item
                label="Valor"
                name="valorFixoImposto"
                rules={[
                  {
                    required: selectedOption === "V" ? true : false,
                    message: "Digite um valor",
                  },
                ]}
              >
                <NumericFormat
                  className="ant-input noBoderColor number-input"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  prefix="R$"
                  fixedDecimalScale={true}
                  onChange={() => form.setFieldValue("valorFixoImposto", realParaNumber(form.getFieldValue("valorFixoImposto")))}
                />
              </Form.Item>
            </Col>
          )}
          {selectedOption === "P" && (
            <Col>
              <Form.Item
                label="Percentual"
                name="percentual"
                rules={[
                  {
                    required: selectedOption === "P" ? true : false,
                    message: "Digite um percentual",
                  },
                ]}
              >
                <NumericFormat
                  className="ant-input noBoderColor number-input"
                  decimalSeparator=","
                  decimalScale={2}
                  suffix="%"
                  fixedDecimalScale={true}
                  onChange={() => form.setFieldValue("percentual", realParaNumber(form.getFieldValue("percentual")))}
                />
              </Form.Item>
            </Col>
          )}
          <Col>
            <Form.Item
              label="Valor mínimo"
              name="valorMinimoAplicacaoImposto"
              rules={[
                {
                  required: true,
                  message: "Preencher",
                },
              ]}
            >
              <NumericFormat
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
                onChange={() => form.setFieldValue("valorMinimoAplicacaoImposto", realParaNumber(form.getFieldValue("valorMinimoAplicacaoImposto")))}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label="Valor máximo"
              name="valorMaximoAplicacaoImposto"
              rules={[
                {
                  required: true,
                  message: "Preencher",
                },
              ]}
            >
              <NumericFormat
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
                onChange={() => form.setFieldValue("valorMaximoAplicacaoImposto", realParaNumber(form.getFieldValue("valorMaximoAplicacaoImposto")))}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="" name="debitaPrincipal" valuePropName="checked">
              <Checkbox>Debita da fonte</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="Descricão" name="descricao">
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0"></Divider>
        <Col>
          <Form.Item label="" name="geraContaFinanceira" valuePropName="checked">
            <Checkbox onChange={handleGeraContaFinanceiraChange}>Gerar Conta Financeira</Checkbox>
          </Form.Item>
        </Col>
        <Collapse activeKey={geraContaIsChecked ? ["1"] : []}>
          <Panel header="Informações da Conta a Pagar de Destino" key="1">
            <Row gutter={12}>
              <Col>
                <Form.Item
                  label="Conta no destino"
                  name="conta_tipoGeracaoContaDestinto"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione um tipo de geração para conta destino.",
                    },
                  ]}
                >
                  <Radio.Group buttonStyle="solid">
                    <Radio.Button value={"U"}>Única</Radio.Button>
                    <Radio.Button value={"M"}>Múltiplas</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="Conta bancária"
                  name="conta_IdContaBanco"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione uma conta bancária",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Selecione uma conta bancária"
                    loading={contaBancoState.loading}
                    options={contaBancoState.list.map((a: Vm_ContaBancoModel) => ({
                      value: a.id,
                      label: a.denominacaoPersonalizada,
                      disabled: !a.ativo,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="Fornecedor"
                  name="conta_IdPessoaFornecedor"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione uma conta bancária",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder="Selecione o fornecedor"
                    onChange={handleFornecedorChange}
                    loading={pessoaState.loading}
                    options={pessoaState.list.map((a: PessoaModel) => ({
                      value: a.id,
                      label: a.apelido,
                      disabled: !a.ativo,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="Favorecido"
                  name="conta_IdPessoaFavorecido"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Digite o nome do favorecido",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder="Selecione o favorecido"
                    loading={pessoaState.loading}
                    options={pessoaState.list.map((a: PessoaModel) => ({
                      value: a.id,
                      label: a.apelido,
                      disabled: !a.ativo,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label="Valor adicional" name="conta_ValorAdicional">
                  <NumericFormat
                    className="ant-input noBoderColor number-input"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    prefix="R$"
                    fixedDecimalScale={true}
                    onChange={() => form.setFieldValue("conta_ValorAdicional", realParaNumber(form.getFieldValue("conta_ValorAdicional")))}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={12} style={{ alignItems: "center" }}>
              {
                <>
                  {" "}
                  <Col span={6}>
                    <Form.Item label="Grupo de plano de conta financeiro" name="idGrupoPlanoContaFinanceiro">
                      <Select
                        showSearch
                        optionFilterProp="label"
                        onChange={handleChangeGrupo}
                        placeholder="Selecione um grupo"
                        allowClear
                        options={grupoPlanoContaFinanceiroState.list.map((grupo: any) => ({
                          value: grupo.id,
                          label: grupo.denominacao,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label={grupo.length !== 0 ? "Plano de conta financeiro de" + " " + grupo : "Plano de conta financeiro"}
                      name="conta_IdPlanoContaFinanceiro"
                      rules={[
                        {
                          required: usaMesmoPlanoIsChecked ? false : true,
                          message: "Selecione um plano de conta.",
                        },
                      ]}
                    >
                      <SelectTree
                        loading={planoContaFinanceiroState.loading}
                        list={planoContaFinanceiroState.list}
                        props={{
                          disabled: usaMesmoPlanoIsChecked ? true : false,
                        }}
                      />
                    </Form.Item>
                  </Col>
                </>
              }
              <Col span={6}>
                <Form.Item label=" " name="conta_UsaPlanoContaFinanceiroOrigem" valuePropName="checked">
                  <Checkbox onChange={handleUsaMesmoPlanoChange}>Usar mesmo plano de conta financeiro da origem</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  label="Centro de custo"
                  name="conta_IdCentroCusto"
                  rules={[
                    {
                      required: usaMesmoCentroCustoIsChecked ? false : true,
                      message: "Preencher",
                    },
                  ]}
                >
                  <SelectTree loading={centroCustoState.loading} list={centroCustoState.list} props={{ disabled: usaMesmoCentroCustoIsChecked ? true : false }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label=" " name="conta_UsaCentroCustoOrigem" valuePropName="checked">
                  <Checkbox onChange={handleUsaMesmoCentroCustoChange}>Usar mesmo centro de custo da origem</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col>
                <Form.Item
                  label="Tipo data referência"
                  name="dataConta_tipoDataReferencia"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione...",
                    },
                  ]}
                >
                  <Select>
                    <Select.Option value="EMI">Emissão</Select.Option>
                    <Select.Option value="VEN">Vencimento</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Regra"
                  name="dataConta_RegraData"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione uma regra.",
                    },
                  ]}
                >
                  <Select>
                    <Select.Option value="1">Último dia do mês seguinte ao Trimestre da data atual</Select.Option>
                    <Select.Option value="2">Plano 2</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item
                  label="Dia"
                  name="dataConta_Dia"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Digite um dia",
                    },
                  ]}
                >
                  <InputNumber controls={false} />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Se não for dia útil"
                  name="dataConta_AcaoDiaNaoUtil"
                  rules={[
                    {
                      required: geraContaIsChecked ? true : false,
                      message: "Selecione...",
                    },
                  ]}
                >
                  <Select>
                    <Select.Option value="A">Antecipa</Select.Option>
                    <Select.Option value="M">Mantém</Select.Option>
                    <Select.Option value="P">Posterga</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  label="Nº de meses adiante"
                  name="dataConta_NumeroAdiante"
                  rules={[
                    {
                      required: false,
                      message: "Digite a quantidade de meses adiante",
                    },
                  ]}
                >
                  <InputNumber controls={false} defaultValue={0} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={24}>
                <Form.Item label="Histórico padrão" name="conta_HistoricoPadrao">
                  <TextArea rows={3} />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        </Collapse>
        <Divider orientation="left" orientationMargin="0"></Divider>
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
                VOLTAR
              </Button>
              <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                {editar ? "ATUALIZAR" : "SALVAR"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Flex>
  );
};

export default CadastrarPage;
